import { History } from "history";

import { SearchRightType, SearchRights } from "@/api/elasticSearch/vmsSearchApi";


export const hasCameraRights = (
    rights: SearchRights,
    type: SearchRightType,
    client_id: number,
    camera_ids: number[],
): boolean => {
    // Typescript can't properly do type narrowing if we use rights[type] directly in the expression below, so
    // we assign it as a work around.
    const rights_type = rights[type];

    return (
        rights_type.type === "all" ||
        rights_type.clients.includes(client_id) ||
        camera_ids.some((camera_id) => rights_type.entities.includes(camera_id))
    );
};

interface canRequestVideoArgs {
    client_id: number;
    camera_ids: number[];
    searchRightsData: { data: SearchRights } | undefined;
    hasCameraRights: (rights: SearchRights, type: SearchRightType, client_id: number, camera_ids: number[]) => boolean;
}

export const canRequestVideo = ({ client_id, camera_ids, searchRightsData, hasCameraRights }: canRequestVideoArgs) => {
    return searchRightsData && hasCameraRights(searchRightsData.data, "request_video", client_id, camera_ids);
};

export const onClickArchiveCabinet = (
    historyObj: History<unknown>,
    acUnitId: number | null,
    closeSearchBody: () => void,
) => {
    if (acUnitId) {
        historyObj.push(`/archive-cabinet/${acUnitId}/history`);
        closeSearchBody();
    }
};

export const getStreamCamera = (
    rights: SearchRights,
    client_id: number,
    primary_camera_id: number | null,
    camera_ids: number[],
): number | null => {
    // Typescript can't properly do type narrowing if we use rights[] directly in the expression below, so
    // we assign it as a work around.
    const rights_type = rights["stream"];

    // if there's a primary camera, check to see if we have access to it.
    if (
        primary_camera_id &&
        (rights_type.type === "all" ||
            rights_type.clients.includes(client_id) ||
            rights_type.entities.includes(primary_camera_id))
    ) {
        return primary_camera_id;
    }

    // If we don't have a primary camera id, but we have access to "all" or all for the clients cameras, then we just
    // grab the first camera
    if (rights_type.type === "all" || rights_type.clients.includes(client_id)) {
        return camera_ids.at(0) || null;
    }

    // If there isn't a primary camera and we don't have access to "all" of the clients cameras camera, find the first camera
    // we do have access to.
    return camera_ids.find((camera_id) => rights_type.entities.includes(camera_id)) || null;
};
